import { useEffect, useRef } from 'react';
import { useKeepAliveActive } from './keepAliveActive';

/** 缓存页隐藏时释放轮询；回到该页时重新订阅，回调始终使用最新筛选条件。 */
export function useActiveInterval(callback: () => unknown, intervalMs: number, immediate = true) {
  const active = useKeepAliveActive();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => {
    if (!active) return;
    const run = () => {
      if (document.visibilityState === 'visible') void callbackRef.current();
    };
    if (immediate) run();
    const timer = window.setInterval(run, intervalMs);
    return () => window.clearInterval(timer);
  }, [active, intervalMs, immediate]);
}
